import script from "./NotificationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationForm.vue?vue&type=script&setup=true&lang=js"

import "./NotificationForm.vue?vue&type=style&index=0&id=2cab9cd9&lang=scss"

const __exports__ = script;

export default __exports__